import React, { useState } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { useTranslation } from 'react-i18next';

import { AvailableMedicalService } from '../../models/Entities/MedicalServices/AvailableMedicalService';
import MedicalServiceListComponent from '../../components/MedicalServices/MedicalServiceList/MedicalServiceListComponent';
import MedicalServicesFormComponent from '../../components/MedicalServices/MedicalServiceForm/MedicalServiceForm.Component';
import { PageHeader } from '../../commons/component/PageHeader/PageHeader';

/** Catálogo de servicios médicos: el listado trae la barra con búsqueda, filtros y "Agregar". */
export const MedicalServicesPage = () => {
  const [selectedItemId, setSelectedItemId] = useState<number>();
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
  const [t] = useTranslation();

  const handleEditEvent = (service: AvailableMedicalService) => {
    setSelectedItemId(service?.id);
    openPanel();
  };

  const handleClosePanel = () => {
    setSelectedItemId(undefined);
    dismissPanel();
  };

  const handleAddClick = () => {
    setSelectedItemId(undefined);
    openPanel();
  };

  return (
    <>
      <PageHeader title={t('medicalServicesPage.medicalServicesTitle')} />
      <div className="Section">
        <MedicalServiceListComponent editEvent={handleEditEvent} onAdd={handleAddClick} />
        <MedicalServicesFormComponent
          isOpen={isOpen}
          dismissPanel={handleClosePanel}
          openPanel={openPanel}
          MedicalServiceId={selectedItemId}
        />
      </div>
    </>
  );
};
